import { faImage, faVideo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export type MediaType = "video" | "image" | null;

interface Props {
  mediaType: MediaType;
}

export const MediaTypeTag: React.FC<Props> = ({ mediaType }) => {
  const style = { fontSize: "14px" };

  const getIcon = () => {
    if (mediaType === "image") {
      return <FontAwesomeIcon icon={faImage} style={style} />;
    }
    if (mediaType === "video") {
      return <FontAwesomeIcon icon={faVideo} style={style} />;
    }
    return null;
  };

  return <Container>{getIcon()}</Container>;
};

const Container = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
  padding: 4px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 4px;
`;
